import api from '@pray/shared/utils/api';
export async function deleteCatalog({ artistId, catalogId }: { artistId: string; catalogId: string }) {
  if (!artistId) throw new Error('Artist ID is required');
  // Unwrap the backend envelope ({ responded_at, object, data }) one level — see getCatalogs.ts.
  const res = await api.executeDeleteRequest<{ data: unknown }>(`/web/studio/artists/${artistId}/catalogs/${catalogId}`);
  return res.data.data;
}
